(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-rail"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('hanging-clothing-rail')) return;

    class HangingClothingRail extends HTMLElement {
      connectedCallback() {
        queueMicrotask(() => { if (this.isConnected) this.initialize(); });
      }

      initialize() {
        if (this.events) return;
        this.viewport = this.querySelector('[data-hr-viewport]');
        this.track = this.querySelector('[data-hr-track]');
        if (!this.viewport || !this.track) return;

        this.events = new AbortController();
        const signal = this.events.signal;
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.hoverDevice = window.matchMedia('(hover: hover) and (pointer: fine)');
        this.prev = this.querySelector('[data-hr-prev]');
        this.next = this.querySelector('[data-hr-next]');
        this.controls = this.querySelector('[data-hr-controls]');
        this.counter = this.querySelector('[data-hr-counter]');
        this.lastDrag = -Infinity;
        this.drag = null;
        this.cards = Array.from(this.querySelectorAll('[data-hr-card]')).map(card => ({
          card,
          stage: card.querySelector('[data-hr-stage]'),
          front: card.querySelector('[data-hr-front]'),
          back: card.querySelector('[data-hr-back]'),
          button: card.querySelector('[data-hr-flip]'),
          text: card.querySelector('[data-hr-flip-text]'),
          hovered: false,
          pinned: false,
          suppressHover: false,
          add: card.querySelector('[data-hr-add]'),
          status: card.querySelector('[data-hr-status]'),
          backImage: card.querySelector('[data-hr-back] img'),
          angle: 0,
          vel: 0,
          ptype: '',
          warmed: false,
          busy: false
        }));

        this.cards.forEach(item => {
          item.stage.addEventListener('pointerdown', event => { item.ptype = event.pointerType; }, { signal });
          item.stage.addEventListener('keydown', () => { item.ptype = 'keyboard'; }, { signal });
          item.stage.addEventListener('focus', () => this.warm(item), { signal });
          item.stage.addEventListener('click', event => {
            if (this.dataset.tap !== 'flip' || !item.back) return;
            if (item.ptype !== 'touch' && item.ptype !== 'pen') return;
            event.preventDefault();
            this.toggle(item);
          }, { signal });
          item.stage.addEventListener('pointerenter', event => {
            this.warm(item);
            if (event.pointerType !== 'mouse' || !this.hoverDevice.matches || this.drag?.active || window.Shopify?.inspectMode) return;
            const bounds = item.stage.getBoundingClientRect();
            const side = event.clientX < bounds.left + bounds.width / 2 ? -1 : 1;
            item.card.style.setProperty('--hr-sway', `${side * Number(this.dataset.sway || 0)}deg`);
            item.card.classList.add('is-hovered');
            if (!item.suppressHover && this.dataset.hoverBack === 'true' && item.back) item.hovered = true;
            this.renderItem(item);
          }, { signal });
          item.stage.addEventListener('pointerleave', () => {
            item.card.classList.remove('is-hovered');
            item.hovered = false;
            item.suppressHover = false;
            this.renderItem(item);
          }, { signal });
          item.button?.addEventListener('click', () => this.toggle(item), { signal });
          item.add?.addEventListener('click', () => this.addToCart(item), { signal });
          item.card.addEventListener('keydown', event => {
            if (event.key !== 'Escape') return;
            item.pinned = false;
            item.hovered = false;
            item.suppressHover = true;
            item.card.classList.remove('is-hovered');
            this.renderItem(item);
          }, { signal });
        });

        this.prev?.addEventListener('click', () => this.move(-1), { signal });
        this.next?.addEventListener('click', () => this.move(1), { signal });
        this.lastScroll = this.viewport.scrollLeft;
        this.timers = [];
        this.viewport.addEventListener('scroll', () => {
          const left = this.viewport.scrollLeft;
          const delta = left - this.lastScroll;
          this.lastScroll = left;
          this.impulse(delta);
          this.scheduleUpdate();
        }, { passive: true, signal });
        this.viewport.addEventListener('keydown', event => {
          if (event.target !== this.viewport) return;
          const rtl = getComputedStyle(this).direction === 'rtl';
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.move((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
          } else if (event.key === 'Home' || event.key === 'End') {
            event.preventDefault();
            const end = this.viewport.scrollWidth - this.viewport.clientWidth;
            this.viewport.scrollTo({ left: event.key === 'Home' ? 0 : end * (rtl ? -1 : 1), behavior: this.behavior() });
          }
        }, { signal });

        if (this.dataset.drag === 'true') this.enableDrag(signal);
        this.addEventListener('shopify:block:select', event => {
          const item = this.cards.find(entry => entry.card.dataset.blockId === event.detail?.blockId);
          item?.card.scrollIntoView({ behavior: 'auto', block: 'nearest', inline: 'center' });
        }, { signal });

        if ('ResizeObserver' in window) {
          this.observer = new ResizeObserver(() => this.scheduleUpdate());
          this.observer.observe(this.viewport);
          this.observer.observe(this.track);
        } else {
          window.addEventListener('resize', () => this.scheduleUpdate(), { signal });
        }
        if ('IntersectionObserver' in window) {
          this.warmer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
              if (!entry.isIntersecting) return;
              const match = this.cards.find(candidate => candidate.card === entry.target);
              if (match) this.warm(match);
              this.warmer.unobserve(entry.target);
            });
          }, { root: this.viewport, rootMargin: '0px 320px' });
          this.cards.forEach(item => { if (item.backImage) this.warmer.observe(item.card); });
          this.intro = new IntersectionObserver(entries => {
            if (!entries.some(entry => entry.isIntersecting)) return;
            this.intro.disconnect();
            this.playIntro();
          }, { threshold: 0.3 });
          this.intro.observe(this);
        } else {
          this.cards.forEach(item => this.warm(item));
        }
        this.setAttribute('data-enhanced', '');
        this.updateNavigation();
      }

      renderItem(item) {
        const back = Boolean(item.back && (item.pinned || item.hovered));
        item.card.classList.toggle('is-back', back);
        item.front?.setAttribute('aria-hidden', String(back));
        item.back?.setAttribute('aria-hidden', String(!back));
        item.button?.setAttribute('aria-pressed', String(back));
        if (item.text) item.text.textContent = back ? this.dataset.labelFront : this.dataset.labelBack;
      }

      toggle(item) {
        item.pinned = !(item.pinned || item.hovered);
        item.hovered = false;
        item.suppressHover = true;
        this.renderItem(item);
      }

      warm(item) {
        if (item.warmed || !item.backImage) return;
        item.warmed = true;
        item.backImage.loading = 'eager';
      }

      swayEnabled() {
        return this.dataset.scrollSway === 'true' && Number(this.dataset.sway) > 0 && !this.motion.matches;
      }

      impulse(delta) {
        if (!delta || !this.swayEnabled()) return;
        const amp = Number(this.dataset.sway);
        const push = Math.max(-1, Math.min(1, delta / 60)) * amp * 0.04;
        this.cards.forEach((item, index) => { item.vel -= push * (1 + (index % 3) * 0.12); });
        this.kick();
      }

      kick() {
        if (this.raf) return;
        this.last = performance.now();
        this.raf = requestAnimationFrame(time => this.tick(time));
      }

      tick(now) {
        this.raf = null;
        const dt = Math.min(2.5, (now - this.last) / 16.667) || 1;
        this.last = now;
        const limit = Number(this.dataset.sway) * 1.6 + 0.5;
        let moving = false;
        this.cards.forEach(item => {
          if (!item.angle && !item.vel) return;
          item.vel += (-0.05 * item.angle - 0.075 * item.vel) * dt;
          item.angle = Math.max(-limit, Math.min(limit, item.angle + item.vel * dt));
          if (Math.abs(item.angle) < 0.01 && Math.abs(item.vel) < 0.01) {
            item.angle = 0;
            item.vel = 0;
            item.card.style.removeProperty('--hr-live');
          } else {
            moving = true;
            item.card.style.setProperty('--hr-live', `${item.angle.toFixed(3)}deg`);
          }
        });
        if (moving) this.raf = requestAnimationFrame(time => this.tick(time));
      }

      playIntro() {
        if (!this.swayEnabled()) return;
        const frame = this.viewport.getBoundingClientRect();
        const amp = Number(this.dataset.sway);
        let order = 0;
        this.cards.forEach((item, index) => {
          const rect = item.card.getBoundingClientRect();
          if (rect.right < frame.left || rect.left > frame.right) return;
          this.timers.push(setTimeout(() => {
            item.vel += (index % 2 ? -1 : 1) * amp * 0.12;
            this.kick();
          }, order * 110));
          order += 1;
        });
      }

      async addToCart(item) {
        if (item.busy || !item.add) return;
        const field = item.card.querySelector('[data-hr-variant]');
        const id = Number(field?.value);
        if (!id) return;
        const root = window.Shopify?.routes?.root || '/';
        item.busy = true;
        item.add.disabled = true;
        item.add.textContent = this.dataset.labelAdding;
        if (item.status) item.status.textContent = '';
        let ok = false;
        try {
          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id, quantity: 1 }] })
          });
          if (!response.ok) throw new Error('Add to cart failed');
          const data = await response.json();
          ok = true;
          item.add.textContent = this.dataset.labelAdded;
          if (item.status) item.status.textContent = this.dataset.labelAdded;
          document.dispatchEvent(new CustomEvent('hanging-rail:cart-add', { detail: data }));
        } catch (error) {
          item.add.textContent = this.dataset.labelAdd;
          if (item.status) item.status.textContent = this.dataset.labelError;
        }
        if (ok && this.dataset.cartAction === 'cart') {
          window.location.assign(`${root}cart`);
          return;
        }
        this.timers.push(setTimeout(() => {
          item.add.textContent = this.dataset.labelAdd;
          item.add.disabled = false;
          item.busy = false;
          if (ok && item.status) item.status.textContent = '';
        }, ok ? 2000 : 0));
      }

      behavior() { return this.motion.matches ? 'auto' : 'smooth'; }

      move(direction) {
        if (!this.cards.length) return;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const step = this.cards[0].card.getBoundingClientRect().width + gap;
        const rtl = getComputedStyle(this).direction === 'rtl';
        this.viewport.scrollBy({ left: step * direction * (rtl ? -1 : 1), behavior: this.behavior() });
      }

      scheduleUpdate() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          if (this.isConnected) this.updateNavigation();
        });
      }

      updateNavigation() {
        const viewport = this.viewport;
        const max = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
        this.toggleAttribute('data-overflow', max >= 2);
        const rtl = getComputedStyle(this).direction === 'rtl';
        const progress = Math.max(0, Math.min(max, viewport.scrollLeft * (rtl ? -1 : 1)));
        if (this.controls) this.controls.hidden = this.dataset.arrows !== 'true' || max < 2;
        if (this.prev) this.prev.disabled = progress < 2;
        if (this.next) this.next.disabled = progress > max - 2;
        if (this.counter && this.cards.length) {
          const frame = viewport.getBoundingClientRect();
          const visible = this.cards.map((item, index) => ({ rect: item.card.getBoundingClientRect(), index }))
            .filter(({ rect }) => rect.right > frame.left + 8 && rect.left < frame.right - 8);
          const current = visible.length ? visible[0].index + 1 : 1;
          this.counter.textContent = `${current} / ${this.cards.length}`;
        }
      }

      enableDrag(signal) {
        const viewport = this.viewport;
        viewport.addEventListener('pointerdown', event => {
          if (event.pointerType !== 'mouse' || event.button !== 0 || event.target.closest('button, input, select, textarea') || window.Shopify?.inspectMode) return;
          if (viewport.scrollWidth <= viewport.clientWidth + 2) return;
          this.drag = { id: event.pointerId, x: event.clientX, y: event.clientY, scroll: viewport.scrollLeft, active: false };
        }, { signal });
        viewport.addEventListener('pointermove', event => {
          const drag = this.drag;
          if (!drag || event.pointerId !== drag.id) return;
          const dx = event.clientX - drag.x;
          const dy = event.clientY - drag.y;
          if (!drag.active) {
            if (Math.abs(dy) > 8 && Math.abs(dy) > Math.abs(dx)) { this.drag = null; return; }
            if (Math.abs(dx) < 7) return;
            drag.active = true;
            viewport.setPointerCapture(event.pointerId);
            viewport.classList.add('is-dragging');
            this.cards.forEach(item => {
              item.hovered = false;
              item.card.classList.remove('is-hovered');
              this.renderItem(item);
            });
          }
          event.preventDefault();
          viewport.scrollLeft = drag.scroll - dx;
        }, { signal });
        const finish = event => {
          const drag = this.drag;
          if (!drag || (event.pointerId !== undefined && drag.id !== event.pointerId)) return;
          if (drag.active) this.lastDrag = performance.now();
          this.drag = null;
          viewport.classList.remove('is-dragging');
          if (viewport.hasPointerCapture(drag.id)) viewport.releasePointerCapture(drag.id);
          this.scheduleUpdate();
        };
        viewport.addEventListener('pointerup', finish, { signal });
        viewport.addEventListener('pointercancel', finish, { signal });
        viewport.addEventListener('lostpointercapture', finish, { signal });
        viewport.addEventListener('pointerleave', event => { if (this.drag && !this.drag.active) finish(event); }, { signal });
        window.addEventListener('blur', () => finish({}), { signal });
        viewport.addEventListener('dragstart', event => event.preventDefault(), { signal });
        viewport.addEventListener('click', event => {
          if (event.detail !== 0 && performance.now() - this.lastDrag < 400) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        }, { capture: true, signal });
      }

      disconnectedCallback() {
        this.events?.abort();
        this.observer?.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
        this.warmer?.disconnect();
        this.intro?.disconnect();
        this.timers?.forEach(timer => clearTimeout(timer));
        this.timers = [];
        if (this.raf) cancelAnimationFrame(this.raf);
        this.raf = null;
        if (this.drag && this.viewport?.hasPointerCapture(this.drag.id)) this.viewport.releasePointerCapture(this.drag.id);
        this.viewport?.classList.remove('is-dragging');
        this.cards?.forEach(item => {
          item.hovered = false;
          item.pinned = false;
          item.angle = 0;
          item.vel = 0;
          item.card.style.removeProperty('--hr-live');
          item.card.classList.remove('is-hovered');
          this.renderItem(item);
        });
        this.removeAttribute('data-enhanced');
        this.events = null;
        this.observer = null;
        this.frame = null;
        this.drag = null;
      }
    }

    customElements.define('hanging-clothing-rail', HangingClothingRail);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
